import React, { useState, useCallback, useEffect } from 'react'
import { 
  Button,
  Box,
  IconButton,
  Dialog,
  DialogContent,
} from '@mui/material'
import ImageIcon from '@mui/icons-material/Image'
import CloseIcon from '@mui/icons-material/Close'
import VisibilityIcon from '@mui/icons-material/Visibility' // プレビュー用アイコンを追加

const PoseSelectButton = ({ onClick, poseImage, externalImage }) => {
  const [selectedImage, setSelectedImage] = useState(null)
  const [openPreview, setOpenPreview] = useState(false)  // プレビューダイアログの状態
  
  const cropToSquare = useCallback((dataUrl) => {
    return new Promise((resolve) => {
      const img = document.createElement('img')
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const size = Math.min(img.width, img.height)
        canvas.width = size
        canvas.height = size
        
        const ctx = canvas.getContext('2d')
        const offsetX = (img.width - size) / 2
        const offsetY = (img.height - size) / 2
        
        ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, size, size)
        resolve(canvas.toDataURL('image/jpeg'))
      }
      img.src = dataUrl
    })
  }, [])

  useEffect(() => {
    if(poseImage.current){
        cropToSquare(poseImage.current).then(croppedImage => {
            setSelectedImage(croppedImage)
        })
    }
  },[poseImage])

  const handlePoseClick = () => {
    onClick()
  }

  const handleReset = () => {
    setSelectedImage(null)
    if (poseImage.current) {
      poseImage.current = null
    }
  }

  const handlePreviewOpen = () => {
    setOpenPreview(true)
  }

  const handlePreviewClose = () => {
    setOpenPreview(false)
  }

  React.useEffect(() => {
    if (externalImage) {
      setSelectedImage(externalImage)
    }
  }, [externalImage])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          onClick={handlePoseClick}
          variant="outlined"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: '8px 16px',
            minWidth: 'auto',
            height: 'auto'
          }}
        >
          {selectedImage ? (
            <>
              <Box
                component="img"
                src={selectedImage}
                alt="Selected pose"
                sx={{
                  width: 32,
                  height: 32,
                  objectFit: 'cover',
                  borderRadius: 1
                }}
              />
              <span>ポーズ指定</span>
            </>
          ) : (
            <>
              <ImageIcon sx={{ width: 24, height: 24 }} />
              <span>ポーズ指定</span>
            </>
          )}
        </Button>
        {selectedImage && (
          <>
            <IconButton 
              onClick={handlePreviewOpen}  // プレビューボタン
              size="small"
              sx={{ 
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
            <IconButton 
              onClick={handleReset}
              size="small"
              sx={{ 
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        )}
      </Box>

      {/* プレビューダイアログ */}
      <Dialog
        open={openPreview}
        onClose={handlePreviewClose}
        maxWidth="md"
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            maxWidth: '90vw',
          }
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box
            component="img"
            src={selectedImage}
            alt="Pose preview"
            sx={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </DialogContent>
        <IconButton
          onClick={handlePreviewClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.6)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Dialog>
    </Box>
  )
}

export default PoseSelectButton